// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".indicator-box .m-chart--params{max-width:unset!important}.indicator-box .data-explorer--param{width:unset!important;flex:1}.indicator-box .m-chart--params>:not(:first-child){margin-left:0!important}.highcharts-data-label span{white-space:nowrap!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
